/**
 * Session stores data that is loaded on any record-detail page and
 * can be viewed by any record-detail specific component.
 */

import urls from '../urls';
import CONSTANTS from '../../constants';

export default {
    namespaced: true,
    state() {
        return {
            customer: {
                id: undefined,
                email: undefined,
            },
            fields: [],
        }
    },
    mutations: {
        setCustomer(state, customer) {
            state.customer = customer;
        },
        setFields(state, fields) {
            state.fields = fields;
        },
    },
    getters: {
        accountFields(state) {
            return state.fields.filter(f => f.entity === CONSTANTS.ACCOUNT_ENTITY);
        },
        contactFields(state) {
            return state.fields.filter(f => f.entity === CONSTANTS.CONTACT_ENTITY);
        },
    },
    actions: {
        init,
    },
};

function init(context, customer, force=false) {
    context.commit('setCustomer', customer);
    context.commit('setFields', CONSTANTS.EXCLUSION_FIELDS);
}
